import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow_estrutural', 'execucao/acordo');

const workflowAcordoActions = {
  gravar: { method: 'POST', url: `${basePath}/{idAcordo}` },
  cancelar: { method: 'PUT', url: `${basePath}/{idAcordo}/cancelar` },
  aprovar: { method: 'PUT', url: `${basePath}/{idAcordo}/passos/aprovar` },
  reprovar: { method: 'PUT', url: `${basePath}/{idAcordo}/passos/reprovar` },
  enviarAnalise: { method: 'PUT', url: `${basePath}/{idAcordo}/passos/analise` },
  status: { method: 'GET', url: `${basePath}/{idAcordo}/status` },
  aprovador: { method: 'GET', url: `${basePath}/{idAcordo}/passos/aprovador` },
  buscaPassosClientes: { method: 'GET', url: `${basePath}/{idAcordo}/passos/cliente` },
  statusPasso: { method: 'GET', url: `${basePath}/{idAcordo}/passos/status` },
  solicitante: { method: 'GET', url: `${basePath}/solicitante` },
  associaUsuarioClienteAprovador: { method: 'POST', url: `${basePath}/{idAcordo}/passos/{idPasso}/cliente/usuario/{idUsuario}` },
};
export default resource => resource(`${basePath}`, {}, workflowAcordoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-acordo.js